














import { Vue, Prop, Component } from 'vue-property-decorator';

/**
 * 画像2枚レイアウトのインストラクション画像
 */
@Component
export default class CameraPageIntroductionPcCardImages extends Vue {
  get shootType(): 'front' | 'diagonal' | 'back' | null {
    if (this.$store.getters['camera/isIdDocFront']) return 'front';
    if (this.$store.getters['camera/isIdDocBack']) return 'back';
    if (this.$store.getters['camera/isIdDocDiagonal']) return 'diagonal';

    return null;
  }

  readonly src = {
    front: [
      [
        '/img/introduction/identity-document/pc_general_card_front@1x.png',
        '/img/introduction/identity-document/pc_general_card_front@2x.png'
      ],
      [
        '/img/introduction/identity-document/tablet_general_card_front@1x.png',
        '/img/introduction/identity-document/tablet_general_card_front@2x.png'
      ]
    ],
    diagonal: [
      [
        '/img/introduction/identity-document/pc_general_card_diagonal@1x.png',
        '/img/introduction/identity-document/pc_general_card_diagonal@2x.png'
      ],
      [
        '/img/introduction/identity-document/tablet_general_card_diagonal@1x.png',
        '/img/introduction/identity-document/tablet_general_card_diagonal@2x.png'
      ]
    ],
    back: [
      [
        '/img/introduction/identity-document/pc_general_card_back@1x.png',
        '/img/introduction/identity-document/pc_general_card_back@2x.png'
      ],
      [
        '/img/introduction/identity-document/tablet_general_card_back@1x.png',
        '/img/introduction/identity-document/tablet_general_card_back@2x.png'
      ]
    ]
  } as const;
}
